<template>
    <div>
        <div v-show="editing" :class="{'w-full': fullWidth}">
            <select-dropdown
                v-if="dropdown"
                v-model="inputValue"
                :options="options"
                ref="dropdown"
                autofocus
                @blur="stopEdit"
                @change="handleChange($event)"
                @close="stopEdit"
                @keydown.esc.prevent="stopEdit"/>
            <simple-input
                ref="input"
                v-else
                v-model="inputValue"
                :class="{'w-full': fullWidth}"
                autofocus
                @input-blur="handleChange($event)"
                @enter="handleChange($event)"
                @escape="stopEdit"
            />
        </div>
        <p
            v-show="!editing"
            :class="[{'h-full w-full': fullWidth}, classes]"
            class="min-h-20"
            @click="startEdit"
        >
            <template v-if="!value && placeholder">
                <span class="text-primary-60 italic">{{ placeholder }}</span>
            </template>
            <template v-else>
                {{ valueFormatted }}
            </template>
        </p>
    </div>
</template>

<script>
import SelectDropdown from './SelectDropdown';
import Input from './Input.vue';
export default {
    components: {SelectDropdown, 'simple-input': Input},
    props: {
        value: {
            default: '',
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        dropdown: {
            type: Boolean,
            default: false,
        },
        options: Array,
        disabled: Boolean,
        autoTranslate: Boolean,
        classes: String,
    },
    data() {
        return {
            editing: false,
        };
    },

    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(value) {
                //
            },
        },
        valueFormatted() {
            if (this.dropdown) {
                let val = this.options.find(i => i.value === this.value)?.label || this.value;

                return (this.autoTranslate ? this.$t(val) : val);
            }

            return this.value;
        }
    },
    methods: {
        handleChange(input) {
            if (!this.editing) return;
            this.$emit('input', input);
            this.stopEdit();
        },
        stopEdit() {
            this.editing = false;
        },
        startEdit() {
            if (this.disabled)
                return;

            this.editing = true;

            this.focusInput();

            this.$emit('start-edit');
        },

        focusInput() {
            this.$nextTick(() => {
                if (this.dropdown)
                    this.$refs.dropdown.open();
                else
                    this.$refs.input.focus()
            });
        },
    },
};
</script>
